export const formatPrice = (price) => {
  if (!price) return '0';
  return new Intl.NumberFormat('ar-SA').format(price);
};

export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('ar-SA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const formatDateTime = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('ar-SA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatRelativeTime = (date) => {
  if (!date) return '';
  
  const now = new Date();
  const past = new Date(date);
  const diffMs = now - past;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  
  if (diffMins < 1) return 'الآن';
  if (diffMins < 60) return `منذ ${diffMins} دقيقة`;
  if (diffHours < 24) return `منذ ${diffHours} ساعة`;
  if (diffDays < 7) return `منذ ${diffDays} يوم`;
  
  return formatDate(date);
};

export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const getStatusColor = (status) => {
  const colors = {
    active: 'success',
    inactive: 'danger',
    pending: 'warning',
    approved: 'success',
    rejected: 'danger',
    suspended: 'danger'
  };
  return colors[status] || 'info';
};

export const getStatusLabel = (status, t) => {
  const labels = {
    active: t?.('status.active') || 'نشط',
    inactive: t?.('status.inactive') || 'غير نشط',
    pending: t?.('status.pending') || 'قيد المراجعة',
    approved: t?.('status.approved') || 'معتمد',
    rejected: t?.('status.rejected') || 'مرفوض',
    suspended: t?.('status.suspended') || 'موقوف'
  };
  return labels[status] || status;
};

/**
 * Export data as CSV file
 * @param {Array} data - Array of objects to export
 * @param {Array} columns - Array of column definitions { key, label }
 * @param {string} filename - Name of the exported file
 */
export const exportToCSV = (data, columns, filename = 'export') => {
  if (!data || data.length === 0) {
    return false;
  }

  // Add BOM for Arabic support
  const BOM = '\uFEFF';
  
  // Create header row
  const headerRow = columns.map(col => `"${col.label}"`).join(',');
  
  // Create data rows
  const dataRows = data.map(item => {
    return columns.map(col => {
      let value = item[col.key];
      
      // Handle nested keys like 'user.name'
      if (col.key.includes('.')) {
        const keys = col.key.split('.');
        value = keys.reduce((obj, key) => obj?.[key], item);
      }
      
      // Format value
      if (value === null || value === undefined) {
        value = '';
      } else if (typeof value === 'object') {
        value = JSON.stringify(value);
      } else if (typeof value === 'boolean') {
        value = value ? 'نعم' : 'لا';
      } else if (col.formatter) {
        value = col.formatter(value);
      }
      
      // Escape quotes and wrap in quotes
      return `"${String(value).replace(/"/g, '""')}"`;
    }).join(',');
  });
  
  // Combine all rows
  const csvContent = BOM + [headerRow, ...dataRows].join('\n');
  
  // Create and download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
  return true;
};
